import { addressComponent, attachDocumentMultiple as attachMultiple } from './common';
import {Text} from '@/utils/services';


const egrul = {
	addr: addressComponent,
	factAddr: addressComponent,	
}
const person = {
	addr: addressComponent,
}
const org = { egrul };
const foreignOrg = {
	addr: addressComponent,
} 

const messages = {
	// шаг 2
	applicant: {
		org,
		person,
		foreignOrg
	},
	// шаг 3
	creditor: {
		person,
		org,
		foreignOrg,
		attachMultiple,
	},
	// шаг 4
	debtor: {
		person,
		org,
		foreignOrg,

	},
	// шаг 5
	debtors: {
		person,
		org,
		foreignOrg,
		attachMultiple,
	},
	// 6
	document: {
		attachMultiple,
	},
	// 7
	params: {
		timeLimitDate: {
			hint: 'Укажите дату или событие, когда должник обязан был исполнить обязательство по договору или закону (ст. 314 ГК РФ). Например, дата возврата займа или окончания оказания услуг.',
		},
		penaltyLimFrom: {
			hint: 'Период образования задолженности: начальная и конечная даты. Конечная дата не может быть позже дня подачи заявления. Взыскание возможно за период после наступления срока исполнения обязательства.'
		},
		penaltySum: {
			hint: `Общая сумма включает основной долг, проценты, неустойку (кроме кредитов) и расходы на исполнительную надпись.
                    <i>Расходы на исполнительную надпись</i> рассчитываются по формуле:
                    федеральный тариф (госпошлина) + региональный тариф (плата за услуги правового и технического характера) с учётом скидок, с округлением до рублей вверх.`
		},
		accountNumber: {
			hint: `*Необходимо указать счёт заявителя для возврата. Если заявитель является юридическим лицом, счёт физического лица указать невозможно.`
		}
	},
	// 8
	account: {
		accountNumberHelper: Text.accountBankDetailsNumberHelperP1,
		hasPrivilegeNote: Text.hasPrivilegeNote,
	}
};

export default messages;